import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

// Utility function to calculate decimal places
function getDecimalPlaces(value: unknown): number {
	if (value === null || value === undefined || value === "") {
		return 0;
	}
	const str = value.toString();
	const dotIndex = str.includes(",") ? str.indexOf(",") : str.indexOf(".");
	return dotIndex >= 0 ? str.length - dotIndex - 1 : 0;
}

export function minDecimalPlacesValidator(minDecimalPlaces: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const decimals = getDecimalPlaces(control.value);

		return decimals >= minDecimalPlaces
			? null
			: {
					minDecimalPlaces: {
						required: minDecimalPlaces,
						actual: decimals,
					},
				};
	};
}

export function maxDecimalPlacesValidator(maxDecimalPlaces: number): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const decimals = getDecimalPlaces(control.value);

		return decimals <= maxDecimalPlaces
			? null
			: {
					maxDecimalPlaces: {
						required: maxDecimalPlaces,
						actual: decimals,
					},
				};
	};
}
